import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { useSnackbar } from 'baseui/snackbar'

import { breakManagementActions } from '../breakManagementSagas'
import { selectBreakManagement } from '../breakManagementSelectors'
import { setForceStopTarget } from '../breakManagementSlice'

const useForceStopModal = () => {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const { enqueue } = useSnackbar()
  const { forceStopTarget, isSubmitting } = useSelector(selectBreakManagement)

  const close = () => {
    dispatch(setForceStopTarget(null))
  }

  const setIsOpen = (isOpen: boolean) => {
    if (!isOpen) close()
  }

  const confirm = () => {
    if (forceStopTarget === null) return

    dispatch({ type: breakManagementActions.FORCE_STOP_BREAK, breakId: forceStopTarget.breakId, enqueue })
    close()
  }

  return {
    isOpen: forceStopTarget !== null,
    isSubmitting,
    title: t('breakManagement:force_stop_modal.title'),
    text: t('breakManagement:force_stop_modal.text', { name: forceStopTarget?.name ?? '' }),
    confirmLabel: t('breakManagement:force_stop_modal.confirm'),
    setIsOpen,
    confirm,
  }
}

export default useForceStopModal
